export default __webpack_public_path__ + "968a8ab38ad3411816881c13a04d01de.jpg";